import React, { useState } from "react";

const dummyRequestsData = [
  {
    id: "REQ-001",
    name: "Ravi Sharma",
    think5Code: "T5W-1001",
    purpose: "Business Discussion",
    requestedDate: "2025-01-25",
    requestedTime: "10:00 AM",
    location: "Mumbai Office",
    remarks: "Discuss new vendor proposal",
    status: "Initiated",
  },
  {
    id: "REQ-002",
    name: "Anita Singh",
    think5Code: "T5W-1023",
    purpose: "Investor Meeting",
    requestedDate: "2025-01-28",
    requestedTime: "02:00 PM",
    location: "Conference Hall",
    remarks: "Share quarterly report",
    status: "Initiated",
  },
];

const GASAppointmentRequests = () => {
  const [requests, setRequests] = useState(dummyRequestsData);

  const updateStatus = (id, newStatus) => {
    setRequests((prev) =>
      prev.map((req) =>
        req.id === id ? { ...req, status: newStatus } : req
      )
    );
  };

  return (
    <div className="min-h-screen bg-black text-cyan-400 px-4 py-6">
      <h2 className="text-xl font-semibold mb-4">Appointment Requests</h2>

      {requests.length === 0 && (
        <p className="text-gray-500 text-sm">No appointment requests.</p>
      )}

      <div className="space-y-4">
        {requests.map((req) => (
          <div
            key={req.id}
            className="border border-cyan-700 rounded-xl p-4 bg-black/50"
          >
            <div className="flex justify-between items-center">
              <h3 className="font-semibold">
                {req.name} ({req.think5Code})
              </h3>
              <span
                className={`px-2 py-1 rounded text-xs font-semibold ${
                  req.status === "Initiated"
                    ? "bg-cyan-700 text-black"
                    : req.status === "Accepted"
                    ? "bg-green-500 text-black"
                    : req.status === "Rejected"
                    ? "bg-red-500 text-black"
                    : "bg-yellow-500 text-black"
                }`}
              >
                {req.status}
              </span>
            </div>

            <div className="mt-2 text-sm text-gray-400">
              <p>
                <strong>Purpose:</strong> {req.purpose}
              </p>
              <p>
                <strong>Date & Time:</strong> {req.requestedDate} at{" "}
                {req.requestedTime}
              </p>
              <p>
                <strong>Location:</strong> {req.location}
              </p>
              <p>
                <strong>Remarks:</strong> {req.remarks}
              </p>
            </div>

            {/* Action Buttons */}
            {req.status === "Initiated" && (
              <div className="mt-3 flex flex-wrap gap-2">
                <button
                  onClick={() => updateStatus(req.id, "Accepted")}
                  className="px-3 py-1 bg-green-500 text-black rounded text-sm"
                >
                  Accept
                </button>
                <button
                  onClick={() => updateStatus(req.id, "Rejected")}
                  className="px-3 py-1 bg-red-500 text-black rounded text-sm"
                >
                  Reject
                </button>
                <button
                  onClick={() => updateStatus(req.id, "Later")}
                  className="px-3 py-1 bg-yellow-500 text-black rounded text-sm"
                >
                  Later
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default GASAppointmentRequests;
